import { noopTelemetry, Telemetry } from '@studoku/shared';
import { App, inject, InjectionKey } from 'vue';

/**
 * How components reach telemetry. The provider adapter is installed once (see
 * `plugins/telemetry.ts`) and handed to the app here; every consumer sees the
 * neutral {@link Telemetry} interface, never a vendor SDK.
 *
 * Non-component modules should take a `Telemetry` parameter instead of
 * reaching for a singleton, so they stay testable with `noopTelemetry()`.
 */
export const telemetryKey: InjectionKey<Telemetry> = Symbol('telemetry');

export function provideTelemetry(app: App, telemetry: Telemetry): void {
    app.provide(telemetryKey, telemetry);
}

/**
 * Telemetry for the current component. Falls back to a no-op so components
 * mounted in tests — where no provider is installed — need no special setup.
 */
export function useTelemetry(): Telemetry {
    return inject(telemetryKey, noopTelemetry, true);
}
